export const PAYMENT_STATES = {
  paymentWaiting: 'payment_waiting',
  paymentPending: 'payment_pending',
  paying: 'paying',
  paid: 'paid',
  paymentPaused: 'payment_paused',
  paymentCanceled: 'payment_canceled',
  paymentRefunded: 'payment_refunded',
  paymentNotCompleted: 'payment_not_completed',
  paymentChargebacked: 'payment_chargebacked',
}

export const PAYMENT_STATES_LIST = Object.values(PAYMENT_STATES)

export const VAT_TYPE = {
  gross: 'gross',
  net: 'net',
}

export const SUCCESSFUL_ORDER_STATES = [
  PAYMENT_STATES.paying,
  PAYMENT_STATES.paid,
  PAYMENT_STATES.paymentWaiting,
  PAYMENT_STATES.paymentPending,
]

export const ORDER_STATES_NON_PAYABLE = [
  PAYMENT_STATES.paying,
  PAYMENT_STATES.paid,
  PAYMENT_STATES.paymentPaused,
  PAYMENT_STATES.paymentCanceled,
  PAYMENT_STATES.paymentRefunded,
  PAYMENT_STATES.paymentChargebacked,
]

export const SELLABLE_TYPES = {
  product: 'Product',
  ticket: 'Ticket',
  upsell: 'Upsell',
}

export const PRICING_PLAN_FORMS_PRIO = {
  one_time: 0,
  installment: 1,
  limited_subscription: 2,
  subscription: 3,
}

export const ORDER_VIEW_TYPES = {
  owner: 'owner',
  payer: 'payer',
}

export const ORDER_TYPES = {
  standard: 'standard',
  bundle: 'bundle',
  bump: 'bump',
  upgrade: 'ticket_upgrade',
}

export const getOrderStateLabel = () => ({
  payment_waiting: I18n.t('react.shared.order_state.waiting.label'),
  payment_pending: I18n.t('react.shared.order_state.pending.label'),
  paying: I18n.t('react.shared.order_state.paying.label'),
  paid: I18n.t('react.shared.order_state.paid.label'),
  payment_paused: I18n.t('react.shared.order_state.paused.label'),
  payment_canceled: I18n.t('react.shared.order_state.canceled.label'),
  payment_refunded: I18n.t('react.shared.order_state.refunded.label'),
  payment_not_completed: I18n.t('react.shared.order_state.not_completed.label'),
  payment_chargebacked: I18n.t('react.shared.order_state.chargebacked.label'),
})

export const getOrderStateTooltip = () => ({
  payment_waiting: I18n.t('react.shared.order_state.waiting.tooltip'),
  payment_pending: I18n.t('react.shared.order_state.pending.tooltip'),
  paying: I18n.t('react.shared.order_state.paying.tooltip'),
  paid: I18n.t('react.shared.order_state.paid.tooltip'),
  payment_paused: I18n.t('react.shared.order_state.paused.tooltip'),
  payment_canceled: I18n.t('react.shared.order_state.canceled.tooltip'),
  payment_refunded: I18n.t('react.shared.order_state.refunded.tooltip'),
  payment_not_completed: I18n.t('react.shared.order_state.not_completed.tooltip'),
  payment_chargebacked: I18n.t('react.shared.order_state.chargebacked.tooltip'),
})

export const ORDER_STATE_COLORS = {
  payment_waiting: '#FF9518',
  payment_pending: '#FF9518',
  paying: '#047443',
  paid: '#047443',
  payment_paused: '#CE0018',
  payment_canceled: '#21282E',
  payment_refunded: '#21282E',
  payment_not_completed: '#21282E',
  payment_chargebacked: '#CE0018',
}
